import * as _ from 'lodash';

export function getWorkflows(): WorkflowSelection[] {
  return window.FAST_FORWARD_TARGETS.workflows;
}
export function getAppTemplates(): AppTemplate[] {
  return window.FAST_FORWARD_TARGETS.appTemplates;
}

export function getFakeLogin() {
  return {
    username: `test+${Math.random()
      .toString(36)
      .slice(5)}@blendlabs.com`.toLowerCase(),
    password: 'Fast123!',
  };
}

export const borrowerTypes: BorrowerType[] = [
  {
    text: 'Single Borrower',
    coborrowerExists: false,
  },
  {
    text: 'Coborrowers',
    coborrowerExists: true,
  },
];

export const coborrowerOptions: CoborrowerOption[] = [
  {
    text: 'Married',
    borrowersMarried: true,
  },
  {
    text: 'Unmarried',
    borrowersMarried: false,
  },
];

export const dataSharingOptions: DataSharingOption[] = [
  {
    text: 'Unrestricted Data',
    restrictedData: false,
  },
  {
    text: 'Restricted Data',
    restrictedData: true,
  },
];

const mortgageTypes: MortgageType[] = [
  {
    text: 'Purchasing',
    loanPurposeType: 'PURCHASE',
  },
  {
    text: 'Refinancing',
    loanPurposeType: 'REFINANCE',
  },
  {
    text: 'Construction',
    loanPurposeType: 'CONSTRUCTION',
  },
];

export function getMortgageLoanPurposeTypes() {
  return _.filter(mortgageTypes, type => {
    const supportedTypes: Mismo.LoanPurposeType[] = window.DEPLOYMENT_CONFIG.enableConstructionLoans
      ? ['PURCHASE', 'REFINANCE', 'CONSTRUCTION']
      : ['PURCHASE', 'REFINANCE'];

    return _.includes<Mismo.LoanPurposeType>(supportedTypes, type.loanPurposeType);
  });
}

export function getLoanTypes() {
  const loanTypes = _.filter(window.SHARED_CONSTANTS.LoanTypes.ALL_RICH, function(loanType) {
    return _.includes(window.DEPLOYMENT_CONFIG.supportedLoanTypes, loanType.value);
  });
  // Move mortgage to the front
  return _.flatten(_.partition(loanTypes, { value: 'MORTGAGE' }));
}
